<template>
  <section id="balance">
    <p>我的余额</p>
    <p class="money">￥<slot name="balance"></slot></span>
    </p>
    <div class="decoration_border"></div>
  </section>
</template>
<script>
  import urls from '../../common/js/urls.js'
  export default {
    name: "personal-balance",
  }

</script>
<style scoped>
 #balance {
    text-align: center;
    display: block;
    position: relative;
    width: 400px;
    height: 120px;
    margin-bottom: 15px;
    margin-left: 20px;
    background: #e37d28;
    color: #fff;
    font-size: 12px;
    padding-top: 24px;
}
p {
    line-height: 17px;
    margin: 0;
}
#balance .money {
    margin-top: 5px;
    font-family: PingFangSC-Medium, Microsoft YaHei;
    font-weight: 500;
    line-height: 50px;
    font-size: 36px;
}
#balance .decoration_border {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    padding: 5px;
}

#balance .decoration_border::after {

    content: "";
    display: block;
    height: 92%;
    width: 97%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border: 2px solid #ffbc42;

}
</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalBalance.vue